<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>고객 지원</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>정품 조회/등록</p>
            </div>
        </div>
    
        <div id="product-select" class="column screen-width ">
            <p style="font-size: 32px; font-weight: bold">정품 조회/등록</p>
            <div class="row align-space-between" style="width: 100%">
                <div id="descrption" class="column" style="display: flex; align-content: center">
                    <p style="font-weight:bold"> 구매하신 제품이나 기존 제품에 대해 정품 확인을 해보세요.</p>
                    <ul style="padding-left:20px">
                        <li> 금호마린테크에서 판매한 제품인지 확인해보세요.</li>
                        <li> 시리얼번호는 제품의 뒤쪽이나 하단에 바코드와 함께 존재합니다.</li>
                        <li> 구매 혹은 기종이 오래된 제품은 결과가 다를 수 있으니 051-293-8589 내선 1번으로 연락부탁드립니다.</li>
                    </ul>
                </div>
            </div>
        </div>
    
        <div class="screen-width" style="
                    height: 2px;
                    background: gray;
                    margin-bottom: 40px;
                "></div>
        <div class="row screen-width">
            <div class="search-view align-center" style="width:50%">
               
                <div class="row align-space-between" style="width:100%">
                    <div class="row">
                        <p style="font-size: 28px; font-weight: bold">
                            시리얼 번호
                        </p>
                        <p style="font-size: 24px; color: gray; margin-left: 16px">
                            *
                        </p>
                    </div>
                    <input type="text" v-model="serialNumber" style="
                                width: 60%;
                                height: 56px;
                                border: 1px solid #a2a2a2;
                                padding: 12px;
                            " />
                </div>
                <div class="row align-center" style="gap:32px">
                    <button style="
                            width: 200px;
                            height: 60px;
                            background: #27afe2;
                            border-radius: 30px;
                            color: white;
                            font-size: 24px;
                            font-weight: bold;
                            margin: 40px 0px;
                        " @click="verifyProduct">
                        조회
                    </button>

                    
                </div>
            </div>
            <div class="divdier"></div>
            <div v-if="actionVerify" style="width:50%">
                <div v-if="product?.product" class="verify column align-center" style="width:100%">
                    <p style="font-size:32px; font-weight:bold; color:#27afe2"> 금호마린테크 판매 제품입니다. </p>
                    <div class="row" style="gap:24px; font-size:20px;">
                        <p style="font-weight:bold">제품명</p>
                        <p>{{product.product}}</p>
                    </div>
                    <div class="row" style="gap:24px; font-size:20px;">
                        <p style="font-weight:bold">출고일</p>
                        <p>{{formatKoreanDate(product.shipping_date)}}</p>
                    </div>
                    <div class="row align-space-between" style="width:100%; margin-top:32px;">
                        <div class="row">
                            <p style="font-size: 28px; font-weight: bold">성함</p>
                        </div>
                        <input type="text" v-model="name" style="
                                    width: 60%;
                                    height: 56px;
                                    border: 1px solid #a2a2a2;
                                    padding: 12px;
                                " />
                    </div>
                    <div class="row align-space-between" style="width:100%;">
                        <div class="row">
                            <p style="font-size: 28px; font-weight: bold">전화번호</p>
                        </div>
                        <input type="text" v-model="phoneNumber" style="
                                    width: 60%;
                                    height: 56px;
                                    border: 1px solid #a2a2a2;
                                    padding: 12px;
                                " />
                    </div>
                    <button style="
                                width: 200px;
                                height: 60px;
                                background: #181e39;
                                border-radius: 30px;
                                color: white;
                                font-size: 24px;
                                font-weight: bold;
                                margin: 40px 0px;
                            " @click="registerProductUser">
                            등록
                        </button>
                </div>
                <div v-if="!product?.product" class="verify column align-center" style="width:100%">
                    <p style="font-size:32px; font-weight:bold; color:#ff4e4e"> 확인이 필요한 제품입니다. </p>
                    <p style="font-size:20px; color:gray">* 051-293-8589 내선 1번으로 연락해주세요. *</p>
                    <p style="font-size:20px; color:gray">* 시리얼번호를 다시 한번 확인해주세요 *</p>
                    
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import DownloadItem from "@/components/DownloadItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import ClassItem from "@/components/ClassItem.vue";

export default {
    props: {
        category: {
            type: String,
            default: "GPS플로터",
        },
    },
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        DownloadItem,
        CustomPagination,
        ClassItem,
    },
    setup() {
        const store = useStore();
        const serialNumber = ref("");
        const name = ref("");
        const phoneNumber = ref("");
        const product = ref("");
        const actionVerify = ref(false);

        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        onMounted(() => {
            store.dispatch("getLectureList");
        });

        const verifyProduct = () => {
            actionVerify.value = true;
            store
                .dispatch("verifyProduct", {
                    serial_number: serialNumber.value,
                })
                .then((res) => {
                    product.value = res;
                })
                .catch((err) => {
                    console.log(err);
                });
        };

        const registerProductUser = () => {
            store
                .dispatch("registerProductUser", {
                    name: name.value,
                    serial_number: serialNumber.value,
                    phone_number: phoneNumber.value
                })
                .then(() => {
                    alert("제품 등록이 완료되었습니다.");
                })
                .catch((err) => {
                    console.log(err);
                    alert("제품 등록이 실패하였습니다.");
                });
        };

        



        return {
            serialNumber,
            name,
            phoneNumber,
            verifyProduct,
            registerProductUser,
            product,
            formatKoreanDate,
            actionVerify
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */

@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }
    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#descrption {
    width: 100%;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

textarea {
    padding: 10px;
    resize: none;
    border: none;
}

textarea:focus {
    outline: none !important;
}

input:focus {
    outline: none !important;
}

.search-view {
    padding: 32px 48px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}


.verify {
    padding: 32px 48px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}
.divdier {
    width: 1px;
    height:100%;
    background: lightgray
}
</style>
